export default {
  GET_USERS (state, data) {
    state.users = data.data
  },
  GET_MORE_USERS(state, data) {
		var users_data = data.data
   
		for (var i = 0; i < users_data.length; i++) {
			state.all_users.push(users_data[i])
		}
	},
  GET_ALL_USERS (state, data) {
    state.all_users = data.data
  },
  GET_USER (state, data) {
    state.user = data
  },
  GET_DELETED_USERS (state, data) {
    state.deleted_users = data.data
  },
  GET_ALL_PUBLIC_USERS (state, data) {
    state.all_public_users = data.data
  },
}
